import useGet from "../useGet";
import { InvoiceSummaryRow } from "../../containers/NewOrderContainer/types";
import moment from "moment";

const useInvoices = (
  page: number,
  rowsPerPage: number,
  sortBy?: number,
  sortDirection?: number,
  dependencies?: any[]
) => {
  let path = "";
  if (sortBy !== null && sortDirection !== null) {
    path = `/api/Invoices?page=${page}&page-size=${rowsPerPage}&sort-by=${sortBy}&sort-direction=${sortDirection}&ts=${new Date().getTime()}`;
  } else {
    path = `/api/Invoices?page=${page}&page-size=${rowsPerPage}&ts=${new Date().getTime()}`;
  }

  const { value, loading } = useGet(
    path,
    "Unable to read invoices",
    [],
    dependencies,
    undefined,
    undefined,
    (v: any) => v && typeof v === "object"
  );

  return {
    invoices:
      value.results &&
      (value.results.map((item: any) => ({
        id: item.id,
        number: item.number,
        branch: item.branch.name,
        dateRaised: moment(item.dateRaised).format("DD/MM/YYYY"),
        raisedBy: (
          (item.raisedBy.firstName ? item.raisedBy.firstName : "") +
          (item.raisedBy.lastName ? " " + item.raisedBy.lastName : "")
        ).trim(),
        amount: item.amount
      })) as InvoiceSummaryRow[]),
    invoicesLoading: loading,
    currentPage: value.currentPage,
    pageSize: value.pageSize,
    pageCount: value.pageCount,
    totalCount: value.totalCount
  };
};

export default useInvoices;
